module.exports = __webpack_public_path__ + "img/logo2_agriedge.ac58e8e6.png";